/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-irqa.scss');

var common = require('./m-common');

var $ = require('jquery');


$(function () {
    $(window).scroll(function () {
        //检测滚走的高度
        var scrollT = $(document).scrollTop();
        //当滚走的高度>=400(天蓝色色块的上边距)，
        //显示返回顶部(.back)，否则隐藏返回顶部
        //获取蓝色色块(container)距离文档顶部的距离
        var offsetT = $("body").offset().top;
        //进行判断
        if (scrollT >offsetT) {
            $(".scoll").show()
        } else {
            $(".scoll").hide()
        }
    })
    
    //点击返回顶部，页面滚走的距离设置为0
    $(".scoll").click(function(){
        //生硬的返回
        // $(document).scrollTop(0)
        //动感的返回
        //animate({键:值},时间) 属性：scrollTop---必须是被元素调用
        $("html,body").animate({
            scrollTop:0
        },1000)
    })
    // 获取当前语言环境
    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();

    // 请求的所有地址
    var ajaxUrl = baseUrl + '/v1/ir/question';
    $.ajax({
        url: ajaxUrl,
        type: 'get',
        dataType: 'json',
        data: {
            lang: lang
        },
        success: function (data) {
            console.log(data, 'url');
            if (data.status) {
                var result = data.result;
                var questionsAnswers = result.map(function (item) {
                    return `<li>
                              <p><i class="fa"></i><strong>${ lang === 'en' ? 'Q.'  : '问：' }</strong><span>${item.question}</span></p>
                                <ul class="answer">
                                    <li>
                                    <sapn class="reply-label"><strong>${ lang === 'en' ? 'A.'  : '答：' }</strong></span>
                                    <span class="reply">${item.answer}</span>
                                   </li> 
                                </ul>
                            </li>`
                }).join('');
                console.log(questionsAnswers, 'questionsAnswers');
                $('#accordion>ul').html(questionsAnswers)

                $(function () {
                    $('.accordions>li').click(function () {
                        let $answer = $(this).children('.answer');
                        $answer.stop();
                        $answer.slideToggle(500);
                        let $otheranswer = $(this).siblings().children('.answer')
                        $otheranswer.slideUp(500);
                        if ($(this).hasClass('current')) {
                            $(this).removeClass('current');
                        } else {
                            $(this).addClass('current');
                        }
                        $(this).siblings().removeClass('current');
                    })
                    $('#ir').addClass('active');

                });
            }


        },
        error: function (msg) {
            console.log(msg);
        }
    })

});




// WEBPACK FOOTER //
// ./src/m/m-irqa.js